import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Cookies from 'js-cookie'

const router = new Router({
  // mode: 'history',
  routes: [
    
    //首页
    {
      path: '/',
      name: '/',
      component: ()=>import('@/views/index'),
      meta:{
        title:'首页',
      }
    },

    //首页
    {
      path: '/index',
      name: 'index',
      component: ()=>import('@/views/index'),
      meta:{
        title:'首页',
        headerMenuActiveIndex:1,
      },
    },

    /*********** 协议 **********/
    {
      path: '/protocol/user-protocol',
      name: 'user-protocol',
      component: ()=>import('@/views/protocol/user-protocol'),
      meta:{
        title:'用户协议',
        headerMenuActiveIndex:1,
      },
    },
    {
      path: '/protocol/privacy-protocol',
      name: 'privacy-protocol',
      component: ()=>import('@/views/protocol/privacy-protocol'),
      meta:{
        title:'隐私协议',
        headerMenuActiveIndex:1,
      },
    },

    /*********** 新闻中心 **********/
    {
      path: '/news-list',
      name: 'news-list',
      component: ()=>import('@/views/news-center/news-list'),
      meta:{
        title:'新闻中心',
        headerMenuActiveIndex:2,
      }
    },
    {
      path: '/news-detail',
      name: 'news-detail',
      component: ()=>import('@/views/news-center/news-detail'),
      meta:{
        title:'新闻详情',
        headerMenuActiveIndex:2,
      }
    },

    /*********** 产品中心 **********/
    {
      path: '/product-list',
      name: 'product-list',
      component: ()=>import('@/views/product-center/product-list'),
      meta:{
        title:'产品中心',
        headerMenuActiveIndex:3,
      }
    },
    {
      path: '/product-detail',
      name: 'product-detail',
      component: ()=>import('@/views/product-center/product-detail'),
      meta:{
        title:'产品详情',
        headerMenuActiveIndex:3,
      }
    },

    /*********** 关于我们 **********/
    {
      path: '/about-us',
      name: 'about-us',
      component: ()=>import('@/views/about-us'),
      meta:{
        title:'关于我们',
        headerMenuActiveIndex:4,
      }
    },

    /*********** 联系我们 **********/
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ()=>import('@/views/contact-us'),
      meta:{
        title:'联系我们',
        headerMenuActiveIndex:5,
      }
    },
  ]
})

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

router.beforeEach(async (to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title;
  }
  //如果从新闻详情页跳转到除（新闻列表页和详情页）的其他地方，清除Cookies临时信息
  if(from.name==='news-detail' && to.name!=='news-detail' && to.name!=='news-list'){
    Cookies.remove('newsPageNum')
    Cookies.remove('newsCurrent')
  }
  //如果从产品详情页跳转到除（产品列表页和产品页）的其他地方，清除Cookies临时信息
  if(from.name==='product-detail' && to.name!=='product-detail' && to.name!=='product-list'){
    Cookies.remove('productPageNum')
    Cookies.remove('productCurrent')
  }
  next()

})
router.afterEach(() => {
  window.scrollTo(0,0);
});

export default router
  